import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';

export type LibraryHealthVariant = 'empty' | 'low';

@Component({
  selector: 'app-library-health-banner',
  standalone: true,
  imports: [CommonModule, TranslateModule],
  templateUrl: './library-health-banner.component.html',
  styleUrls: ['./library-health-banner.component.scss'],
})
export class LibraryHealthBannerComponent {
  @Input() variant: LibraryHealthVariant = 'low';

  @Output() goToLibrary = new EventEmitter<void>();
}
